import {
  getCarHouseUsers,
  createCarHouseUser,
  updateCarHouseUser,
  deleteCarHouseUser,
} from '../../lib/carHouseUser';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchCarHouseUsers = createAsyncThunk(
  'carHouseUser/fetchCarHouseUsers',
  async ({ carHouseId, pagination, options }) => {
    const data = await getCarHouseUsers(
      carHouseId,
      pagination,
      options
    );
    return data;
  }
);

export const addCarHouseUser = createAsyncThunk(
  'carHouseUser/addCarHouseUser',
  async ({ carHouseId, body }, { rejectWithValue }) => {
    try {
      const data = await createCarHouseUser(carHouseId, body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editCarHouseUser = createAsyncThunk(
  'carHouseAdmin/editCarHouseUser',
  async ({ carHouseId, userId, body }, { rejectWithValue }) => {
    try {
      const response = await updateCarHouseUser(carHouseId, userId, body);
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const removeCarHouseUser = createAsyncThunk(
  'carHouseAdmin/removeCarHouseUser',
  async ({ carHouseId, userId }) => {
    await deleteCarHouseUser(carHouseId, userId);
    return userId;
  }
);
